"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styles = require("./styles");
var _bricksUtils = require("@titelmedia/bricks-utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Loader = ({
  backgroundColor,
  logoColor
}) => {
  const [visible, setVisible] = (0, _react.useState)(true);
  const containerRef = (0, _react.useRef)(null);
  const tl = _bricksUtils.gsap.timeline();
  (0, _react.useEffect)(() => {
    if (visible === true) {
      const ageGate = document.querySelector('.age-gate');
      if (_bricksUtils.ScrollSmoother?.get()) {
        _bricksUtils.ScrollSmoother.get().paused(true);
      }
      _bricksUtils.gsap.set(document.body, {
        overflow: 'hidden'
      });
      tl.set(containerRef.current, {
        opacity: 1
      }).reveal(containerRef.current, {
        delay: 3,
        duration: 0.25
      }).add(enableScroll);
      function enableScroll() {
        if (ageGate === null) {
          if (_bricksUtils.ScrollSmoother?.get()) {
            _bricksUtils.ScrollSmoother.get().paused(false);
          }
          _bricksUtils.gsap.set(document.body, {
            overflow: 'auto'
          });
        }
        setVisible(false);
      }
    }
  }, []);
  return _react.default.createElement(_react.default.Fragment, null, visible === true && _react.default.createElement(_styles.LoaderContainer, {
    ref: containerRef,
    backgroundColor: backgroundColor?.hex || backgroundColor || '#000000'
  }, _react.default.createElement(_styles.LogoContainer, null, _react.default.createElement("svg", {
    width: 72,
    height: 72,
    viewBox: "0 0 72 72"
  }, _react.default.createElement("path", {
    fill: logoColor?.hex || logoColor || '#FFFFFF',
    d: "M16 22.461V50.21h5.841V37.988h6.572v12.221h5.842V22.461h-5.842v10.992h-6.572V22.46H16zm40.211 6.918c0-2.537-.307-7.379-8.032-7.379-5.38 0-9.185 2.267-9.185 7.379 0 4.112 1.653 5.842 5.227 8.032l3.459 2.114c1.575.96 3.035 1.653 3.035 3.92 0 1.96-1.114 3.075-3.074 3.075-2.344 0-3.151-1.384-3.151-4.15v-.731h-5.88v1.73c0 3.612 1.614 7.34 8.416 7.34 6.456 0 9.531-2.652 9.531-7.994 0-3.036-.846-4.88-4.266-7.033l-5.61-3.574c-1.23-.769-1.768-1.807-1.768-2.96 0-1.844 1.114-3.074 2.805-3.074 1.845 0 2.805 1.23 2.805 3.612v.654h5.688v-.961z"
  })), _react.default.createElement(_styles.Spinner, {
    color: logoColor?.hex || logoColor || '#FFFFFF'
  }))));
};
exports.Loader = Loader;
//# sourceMappingURL=index.js.map